import { lazy } from 'react';

export const ArticlesBlogPage = lazy(() => import('./ArticlesBlogPage'));
